<template>
    <div id="modulbelajar">
        <!-- begin breadcrumb -->
        <ol class="breadcrumb pull-right">
            <li><router-link :to="{path: '/'}">Home</router-link></li>
            <li>Modul Belajar</li>
        </ol>
        <!-- end breadcrumb -->
        <!-- begin page-header -->
        <h1 class="page-header">Daftar Modul Belajar</h1>
        <div class="row">
          <div class="col-md-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <div class="panel-heading">
                <div class="btn-group pull-right">
                  <button type="button" class="btn btn-success btn-xs" @click="createModul()"><span class="fa fa-plus"></span> Tambah Modul</button>
                </div>
                <h4 class="panel-title">Video Pembelajaran</h4>
              </div>
              <div class="panel-body">
                <app-datatable :items="modules" :has-action="true" :headers="headers"
                  v-on:selected="selectedRow = $event" v-on:dblClicked="editModulBelajar()"
                  v-on:deleted="deleteModulBelajar($event)"></app-datatable>
              </div>
            </div>
          </div>
        </div>
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>
<script>
import DataTable from '@/components/plugins/DataTable'
import AppSpinner from '@/components/plugins/Spinner'
import Modal from '@/components/plugins/Modal'
import Moment from 'moment'

import ItembankService from '@/services/itembank.js'

export default {
    name: 'modul-belajar',
    components: {
      'app-datatable': DataTable,
      'app-spinner': AppSpinner
    },
    data: function () {
      return {
        isLoading: false,
        selectedRow: null,
        headers: ['gambar', 'nama', 'kode join'],
        modules: []
      }
    },
    methods: {
      createModul: function() {
        this.$router.push({path: '/modul-belajar/form'})
      },
      loadModulData: function () {
        this.modules = []
        var context = this
        this.isLoading = true
        ItembankService.getListModulBelajar(function (response) {
          context.isLoading = false
          if (response.success) {
            response.data.forEach(function(modul) {
              var row = {
                id: modul.id,
                data: ['<img src="'+modul.picture+'" class="rounded-corner height-50 width-50">', modul.name, modul.join_code]
              }

              context.modules.push(row)
            })
          }
        })
      },
      editModulBelajar: function () {
        var modulId = this.selectedRow.id
        this.$router.push({path: '/modul-belajar/form', query: {id: modulId}})
      },
      deleteModulBelajar: function (modul) {
        var confirmed = window.confirm("Apakah anda yakin akan menghapus modul ini?")
        if (confirmed) {
          this.isLoading = true
          var context = this
          ItembankService.deleteModulBelajar(modul.id, function (response) {
            context.isLoading = false
            if (response.success) {
              context.loadModulData()
            }
          })
        }
      },
    },
    mounted: function () {
      this.loadModulData()
    }
}
</script>



// WEBPACK FOOTER //
// ModulBelajar.vue?9f3edd54